<template>
  <div class="login-wrap">
    <div class="login-html">
      <!-- <input id="tab-1" type="radio" name="tab" class="sign-in" checked><label for="tab-1" class="tab">Giriş</label>
		<input id="tab-2" type="radio" name="tab" class="sign-up"><label for="tab-2" class="tab">Qeydiyyat</label> -->
      <div class="login-form">
        <div class="sign-in-htm">
          <div class="group">
            <label for="user" class="label">FİN</label>
            <input
              id="user"
              maxLength="7"
              type="text"
              class="input"
              v-model="pin"
              @keypress="handleKeyPress"
            />
            <p class="error-text">{{ pinError }}</p>
          </div>
          <div class="group">
            <label for="pass" class="label">ŞİFRƏ</label>
            <input
              id="pass"
              type="password"
              class="input"
              v-model="password"
              data-type="password"
              @keypress="handleKeyPress"
            />
            <p class="error-text">{{ passwordError }}</p>
          </div>
          <div class="group">
            <input id="check" type="checkbox" class="check" checked />
            <!-- <label for="check"><span class="icon"></span> Yadda saxla</label> -->
          </div>
          <div class="group">
            <button
              type="button"
              style="cursor: pointer"
              class="button"
              @click="login"
              :disabled="loadVisible"
            >
              <span class="spin-container">
                <a-spin size="large" :spinning="loadVisible" />
              </span>
              <span>Daxil ol</span>
            </button>
          </div>
          <div class="hr"></div>
          <div class="foot-lnk"><a href="/forgot">Şifrəni unutdum</a></div>
          <div>
            <a
              href="http://mreg.asan.org?o=http://icra.asan.org"
              class="asan-login-btn"
            >
              <img
                src="data:image/png;base64,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"
                alt="Asan Login"
              />
              <span>ASAN Login</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
export default {
  name: "Login",
  data() {
    return {
      pin: null,
      password: null,
      pinError: null,
      passwordError: null,
      loadVisible: false,
    };
  },
  methods: {
    validate() {
      let canSubmit = false;
      if (!this.pin) {
        this.pinError = "FİN daxil edilməyib";
        canSubmit = false;
      } else if (this.pin.length != 7) {
        this.pinError = "FİN 7 simvoldan ibarət olmalıdır";
        canSubmit = false;
      } else {
        this.pinError = null;
        canSubmit = true;
      }
      if (!this.password) {
        this.passwordError = "Şifrə daxil edilməyib";
        canSubmit = false;
      } else if (this.password.length < 8) {
        this.passwordError = "Şifrə minimum 8 simvoldan ibarət olmalıdır";
        canSubmit = false;
      } else {
        canSubmit = true;
      }
      return canSubmit;
    },
    login() {
      if (!this.validate()) return;
      this.loadVisible = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "auth/authenticate",
        method: "POST",
        data: { username: this.pin, password: this.password },
      })
        .then((response) => {
          if (!response.data.error) {
            this.$cookie.set("TOKEN", response.data.data);
            this.getUserProfile();
          }
        })
        .catch((err) => {
          console.dir(err);
          this.loadVisible = false;
          if (err.response.data.error)
            this.$message.error(err.response.data.error.message);
          else if (
            err.response.data.exception.indexOf("UsernameNotFoundException") !=
            -1
          ) {
            this.$message.error(err.response.data.message);
          } else if (err.response.data.error) {
            this.$message.error(err.response.data.error.message);
          } else this.$message.error("Xəta baş verdi");
        });
    },
    getUserProfile() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "users/me",
        method: "POST",
        params: { detailed: true },
      })
        .then((response) => {
          if (!response.data.error) {
            let steps = response.data.data.steps;
            if (steps && steps.length > 0) {
              sessionStorage.setItem("userGroupType", steps[0].id);
            }
            if (steps.length > 0) this.$router.push(steps[0].defaultPath);
            else this.$router.push("/admin");
          }
          this.loadVisible = false;
        })
        .catch((err) => {
          this.loadVisible = false;
          
        });
    },
    handleKeyPress(e) {
      if (e.keyCode == 13) this.login();
    },
  },
  async created() {},
};
</script>

<style lang="scss" src="./index.scss"></style>
